module.exports = __webpack_public_path__ + "img/left-arrow.6a4712a5.svg";